import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink, BrowserRouter, useHistory } from "react-router-dom";
//import { browserHistory } from 'react-router'
import config from "../../config";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import Select from "react-validation/build/select";
import CheckButton from "react-validation/build/button";
import { selectDistrict, selectState } from "../Actions/CommonAction";
import {
  addInstitute,
  getUniversityList,
  createMapRecruiterUniversityList,
} from "../Actions/AdminAction";
import { token } from "../Actions/AuthAction";
import Loader from "../Common/Loader";
import ShowError from "../Common/Error";

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};
const AddLinking = (props) => {
  console.log(props.rec_id);
  const form = useRef();
  const checkBtn = useRef();
  const [universityList, setUniversityList] = useState({
    value: "",
    error: "",
    options: [],
    isRequired: true,
  });
  const [university, setUniversity] = useState({
    value: "",
    error: "",
    options: [],
    isRequired: true,
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(undefined);
  const [error, setError] = useState(undefined);
  const [setpasserror, setPassError] = useState(false);
  const [message, setMessage] = useState("");
  const [refresh, setRefresh] = useState(true);

  const pagepath = "/recruiterlinkinguniversity/" + props.inst_id;
  const redirectpath = "/recruiterlist";

  let history = useHistory();

  useEffect(() => {
    getUniversityList({
      page: -1,
      search: "",
      status: 1,
      city: "",
      state: "",
      limit: 1000,
      key: token(),
    }).then((res) => {
      setUniversityList({ ...universityList, options: res.data });
    });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    //localStorage.setItem("test", 'dfasdf');
    //alert(password);return false;

    setMessage("");
    setLoading(true);

    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      createMapRecruiterUniversityList({
        key: token(),
        rect_id: props.rec_id,
        uinversityid: university.value,
      }).then((res) => {
        //alert(res);
        if (res.status) {
          setError(res.message);
          setPassError(true);
          setLoading(false);
          setStatus(res.status);
          //history.push("/universityadd");
          //window.location.reload();
        } else {
          setMessage(res.message);
          setLoading(false);
          setPassError(false);
          return false;
        }
      });
    } else {
      setLoading(false);
    }
  };

  const onHideModal = () => {
    setError(undefined);
  };
  return (
    <>
      {loading && <Loader />}

      {error && (
        <ShowError
          datastatus={status}
          datapagepath={pagepath}
          dataredirectpath={redirectpath}
          message={error}
          passerror={setpasserror}
          toggleModal={onHideModal}
          datarefresh={refresh}
        />
      )}
      <div className="card formcard mb-3">
        <h4 className="table_heading position-relative">Link University</h4>

        <div className="card-body">
          <Form className="auth_form" ref={form}>
            <div className="row">
              <div className="form-group col-md-6">
                <label className="small mb-1" for="inputPassword">
                  Universities
                </label>
                <Select
                  class="form-control rounded-pill"
                  title="Select State"
                  onChange={(e) =>
                    setUniversity({ ...university, value: e.target.value })
                  }
                  value={university.value}
                >
                  <option selected>Choose University</option>
                  {universityList.options !== undefined &&
                    universityList.options.map((item) => (
                      <option value={item.id}>{item.university_name}</option>
                    ))}
                  validations={[required]}
                </Select>
              </div>

              <div className="form-group mt-4 mb-0">
                <button
                  onClick={handleSubmit}
                  className="btn btn-primary-custom mx-2"
                >
                  Add
                </button>
                {loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
                {message && (
                  <div className="form-group">
                    <div className="alert alert-danger" role="alert">
                      {message}
                    </div>
                  </div>
                )}
                <CheckButton style={{ display: "none" }} ref={checkBtn} />
                <Link
                  className="btn btn-secondary-custom mx-2"
                  to="/recruiterlist"
                >
                  Back
                </Link>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default AddLinking;
